import { Link } from "react-router-dom";

export default function CTASection() {
  return (
    <section className="relative py-20 md:py-28 bg-gradient-to-br from-accent-100/50 to-background-50 overflow-hidden">
      <div className="absolute top-[-60px] right-[-40px] w-[280px] h-[280px] rounded-full bg-accent-200/20 blur-3xl"></div>
      <div className="absolute bottom-[-80px] left-[-30px] w-[320px] h-[320px] rounded-full bg-secondary-200/20 blur-3xl"></div>
      <div className="relative z-10 max-w-[800px] mx-auto px-6 md:px-10 text-center">
        <p className="text-accent-500 text-sm font-medium tracking-wide uppercase mb-3">
          Ready to Start?
        </p>
        <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 leading-tight mb-5">
          Find Your Next Favorite Item Today
        </h2>
        <p className="text-foreground-500 text-base md:text-lg mb-8 max-w-[520px] mx-auto leading-relaxed">
          Join thousands of shoppers who use pandabuyspreadsheet to discover trending fashion, compare quality, and save hours every week.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center justify-center gap-2 px-8 py-3.5 text-sm font-semibold rounded-full bg-foreground-950 text-background-50 hover:bg-foreground-800 transition-all duration-200 whitespace-nowrap cursor-pointer group"
          >
            Open Pandabuy Sheet
            <i className="ri-arrow-right-up-line group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform"></i>
          </a>
          <Link
            to="/article/pandabuy-sheet-complete-guide"
            className="inline-flex items-center justify-center gap-2 px-8 py-3.5 text-sm font-semibold rounded-full border-2 border-foreground-950 text-foreground-950 hover:bg-foreground-950 hover:text-background-50 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            Read Full Guide
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}